import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toggle } from "../../../utils/api";
import { changeDistributor } from "../HomeHandler";
import style from "../css/Home.module.css";
import DownArrow from "../../../icons/down-arrow.png";
import pdlogo from "../../../icons/punnyaDharaLogo.svg";
import Loader from "../../../commonComponent/Loader/Loader";

function Header(props) {
  const homeState = useSelector((state) => state.home);

  return (
    <div className={style.nav}>
      <img src={pdlogo} alt="pdlogo" style={{ width: "150px" }} />
    </div>
  );
}

export default Header;
